import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';
import { imageUrl } from '@/vm/Shared/imageUrl';

export const StepWrapper = createComponent('div', {
  className: 'flex w-full flex-col items-center bg-grey-1'
});

export const BottomNote = createComponent('div', {
  className: cx(
    'flex flex-col items-center gap-x-20 sm:flex-row',
    'bg-white text-center sm:text-left',
    'mx-20 mb-56 mt-20 p-20'
  )
});

export const BottomImage = createComponent('div', {
  className: 'm-12 text-center sm:text-left'
});

export const GraphicWrapper = createComponent('div', {
  className: cx(
    'flex flex-col justify-center sm:flex-row',
    'w-[329px] sm:h-[90px] sm:w-auto',
    'mx-auto p-16 sm:mb-[100px] sm:p-0',
    '[background-image:var(--mobile-image)] sm:[background-image:var(--desktop-image)]',
    'bg-[length:170px_436px] bg-center bg-no-repeat sm:bg-[length:640px]'
  ),
  style: {
    '--desktop-image': `url(${imageUrl('line16.png')})`,
    '--mobile-image': `url(${imageUrl('line17.png')})`
  }
});
